import { GzComplexEnumListWebComponent } from './component/GzComplexEnumListWebComponent';

export { GzComplexEnumListWebComponent };
